// extracted by mini-css-extract-plugin
var _1 = "ProvisionSSODefaultBadge-module__badge--e047p";
export { _1 as "badge" }
